/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
// import './App.css';
import styles from './App.module.css';

// components
// components
import Header from '../header/Header';
import About from '../header/About';
import Footer from '../footer/Footer';
import Main from '../main/Main';

import data from '../../logic/data';

/*****************************************
 * * CREATE APP COMPONENT
 *****************************************/

class App extends Component {
  state = {
    groupIdx: data.groupIdx,
    exampleIdx: data.exampleIdx,
  };

  handleExampleChange = (groupIdx, exampleIdx) => {
    // console.log('[EXAMPLE]', val + 1);
    this.setState({
      groupIdx,
      exampleIdx,
    });
  };

  render() {
    return (
      <div className={styles.gridContainer}>
        <Header />
        <About />


        <Main
          exampleIdx={this.state.exampleIdx}
          onExampleChange={this.handleExampleChange}
        />

        <Footer />
      </div>
    );
  }
}

export default App;
